// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDaySliceResponse
 */
export interface UserDaySliceResponse {
    /**
     * 
     * @type {string}
     * @memberof UserDaySliceResponse
     */
    userLabel: string;
    /**
     * 
     * @type {number}
     * @memberof UserDaySliceResponse
     */
    conversations: number;
    /**
     * 
     * @type {number}
     * @memberof UserDaySliceResponse
     */
    turns: number;
}

/**
 * Check if a given object implements the UserDaySliceResponse interface.
 */
export function instanceOfUserDaySliceResponse(value: object): value is UserDaySliceResponse {
    if (!('userLabel' in value) || value['userLabel'] === undefined) return false;
    if (!('conversations' in value) || value['conversations'] === undefined) return false;
    if (!('turns' in value) || value['turns'] === undefined) return false;
    return true;
}

export function UserDaySliceResponseFromJSON(json: any): UserDaySliceResponse {
    return UserDaySliceResponseFromJSONTyped(json, false);
}

export function UserDaySliceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDaySliceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userLabel': json['user_label'],
        'conversations': json['conversations'],
        'turns': json['turns'],
    };
}

export function UserDaySliceResponseToJSON(json: any): UserDaySliceResponse {
    return UserDaySliceResponseToJSONTyped(json, false);
}

export function UserDaySliceResponseToJSONTyped(value?: UserDaySliceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_label': value['userLabel'],
        'conversations': value['conversations'],
        'turns': value['turns'],
    };
}

